import { exportCanvasToPDF } from '../utils/exportPDF';
import { exportCanvasToA3 } from '../utils/exportA3';
import { exportCardsToExcel } from '../utils/exportExcel';
import { exportCanvasToImage } from '../utils/exportImage';
import { generateLeanReport } from '../utils/leanReport';
import { exportEnterpriseReport } from '../utils/exportEnterpriseReport'; // Nova importação
import { CardData, Project, Action } from '../types';

export const exportService = {
  async toPDF(element: HTMLElement, projectName: string) {
    return exportCanvasToPDF(element, projectName);
  },

  async toA3(element: HTMLElement, projectName: string) {
    return exportCanvasToA3(element, projectName);
  },

  async toExcel(cards: CardData[], projectName: string) {
    return exportCardsToExcel(cards, projectName);
  },

  async toImage(element: HTMLElement, projectName: string) {
    return exportCanvasToImage(element, projectName, 'png');
  },

  async generateLeanReport(project: Project, actions: Action[], metrics: any) {
    return generateLeanReport(project, actions, metrics);
  },

  // Nova função para exportar relatório Enterprise
  async toEnterpriseReport(
    canvasElement: HTMLElement, 
    project: { name: string }, 
    cards: any[], 
    metrics: any
  ) {
    return exportEnterpriseReport(canvasElement, project, cards, metrics);
  }
};
